

export class LoginRequest {
    username: string;
    password: string;
    reEnteredPassword?: string;
    
    /**
     * 
     * @param username 
     * @param password 
     * @param reEnteredPassword
     */
    constructor(username: string, password: string, reEnteredPassword?: string) {
        this.username = username;
        this.password = password;
        this.reEnteredPassword = reEnteredPassword;
    }
}